import React from 'react';
import ElementDataRow from 'components/common/element-data/ElementDataRow';
import { ElementMetadataFieldName, IElementDataLastDataPoint } from 'components/common/element-data/types';
import ElementDataRowLabel from 'components/common/element-data/ElementDataRowLabel';
import ElementDataRowValue from 'components/common/element-data/ElementDataRowValue';
import useBundleTranslation from 'i18n';
import { getFieldElementMetadataSettings } from 'components/common/element-data/functions';

export default function LastDataPoint(props: IElementDataLastDataPoint) {
    const { t } = useBundleTranslation(['components/common/element_data']);
    const { lastMeasurementTimeFormatted = '', settings } = props;
    const fieldKey: ElementMetadataFieldName = 'last_data_point';
    const { fieldMetadataDisplay, fieldMetadataOrder } = getFieldElementMetadataSettings(settings, fieldKey);

    if (!fieldMetadataDisplay || !lastMeasurementTimeFormatted) return null;

    return (
        <ElementDataRow order={fieldMetadataOrder}>
            <ElementDataRowLabel>{t(`element_data_label.${fieldKey}`)}</ElementDataRowLabel>
            <ElementDataRowValue>{lastMeasurementTimeFormatted}</ElementDataRowValue>
        </ElementDataRow>
    );
}
